angular.module('impactx.deliverycomplaint').controller('SimpleComplaintItemCtrl', SimpleComplaintItemCtrl);

function SimpleComplaintItemCtrl() {
    var $ctrl = this;

    var canSelect = function($event) {
        return !$ctrl.item.readOnly && !getParentNode($event.target,"BUTTON") &&
            !getParentNode($event.target,"MD-RADIO-BUTTON") &&
            !getParentNode($event.target,"MD-SELECT") &&
            !getParentNode($event.target,"MD-SELECT-VALUE") &&
            !getParentNode($event.target,"MD-CHECKBOX") &&
            !getParentNode($event.target,"TEXTAREA") &&
            (!getParentNode($event.target,"INPUT") ||
                getParentNode($event.target,"INPUT").getAttribute("disabled")) &&
            $event.target.getAttribute("role") !== "button";
    };

    var getParentNode = function (source, parentTagName) {
        var toCheck = source;
        while(toCheck != null) {
            if(toCheck.tagName === parentTagName) {
                return toCheck;
            }
            toCheck = toCheck.parentNode;
        }
    };

    $ctrl.toggleSelected = function ($event) {
        if($event) {
            if (!$ctrl.isDeleted && canSelect($event)) {
                $ctrl.item.selected = !$ctrl.item.selected;
                if ($ctrl.item.selected) {
                    if ($ctrl.selectedItem.value) {
                        $ctrl.selectedItem.value.selected = false;
                    }
                    $ctrl.selectedItem.value = $ctrl.item;
                }
                else {
                    $ctrl.selectedItem.value = null;
                }
            }
        }
    };

    $ctrl.showInternalComments = function() {
        var comm = $ctrl.item.comments.internalComments;
        if (!$ctrl.showComments) {
            //no "showComments" at all -> no comments available, even if set.
            return false;
        }
        return ($ctrl.item.selected && $ctrl.showComments.value) ||
            (comm.comments && comm.comments.length) || (comm.newComments && comm.newComments.length);
    };

    $ctrl.showExternalComments = function() {
        //always show external comments, even if $ctrl.showComments.value is false. This is needed, so comments are
        //only shown for non deleted items.
        return $ctrl.showComments;
    };
}
